import { Grid } from '@material-ui/core';
import { Document } from '@roc/feature-types';
import { Button, StandardDialog } from '@roc/ui';
import React from 'react';
import { useDocumentStore } from '../../../hooks/useDocumentStore';
import { BorrowerClosingAgent } from './borrowerClosingAgent';
import { CustomTaskDialog } from '@roc/feature-general-tasks';
import { WithDocumentActions } from '../../..';

export type BorrowerClosingAgentDialogProps = {
  open?: boolean;
  onClose?: () => void;
  document: Document;
};

export const BorrowerClosingAgentDialog = (
  props: BorrowerClosingAgentDialogProps
) => {
  const { open, onClose, document } = props;
  const taskId = document?.taskId;
  const { documentStore } = useDocumentStore();
  const { documentFormStore } = documentStore;
  const { borrowerClosingAgentStore } = documentFormStore;
  const { canEdit } = borrowerClosingAgentStore;

  const onSubmit = () => {
    borrowerClosingAgentStore.submitBorrowerAgent(document);
  };

  const getActions = () => {
    return (
      <Grid container spacing={1} justifyContent="flex-end">
        <Grid item>
          <Button
            onClick={onClose}
            color="primary"
            variant="outlined"
            testId="cancel"
          >
            Cancel
          </Button>
        </Grid>
        <Grid item>
          <WithDocumentActions
            document={document}
            component={Button}
            onClick={onSubmit}
            color="primary"
            variant="contained"
            testId="confirm"
            disabled={!canEdit}
          >
            Submit
          </WithDocumentActions>
        </Grid>
      </Grid>
    );
  }

  return (
    <>
      {taskId ? (
        <CustomTaskDialog
          open={open}
          title="Borrower Attorney"
          maxWidth="lg"
          handleClose={onClose}
          dialogContent={<BorrowerClosingAgent />}
          dialogActions={getActions()}
          taskId={taskId}
        />
      ) : (
        <StandardDialog
          open={open}
          title="Borrower Attorney"
          maxWidth="lg"
          handleClose={onClose}
          dialogContent={<BorrowerClosingAgent />}
          dialogActions={getActions()}
        />
      )}
    </>
  );
};

export default BorrowerClosingAgentDialog;
